












import Vue from 'vue'
import FloatingStepsDesktop from '@/components/FloatingStepsDesktop.vue'
import FloatingStepsMobile from '@/components/FloatingStepsMobile.vue'

export default Vue.extend({
  name: 'FloatingSteps',
  components: {
    FloatingStepsDesktop,
    FloatingStepsMobile,
  },
  data: () => ({
    desktopBreakpoints: ['md', 'lg', 'xl'],
    mobileBreakpoints: ['xs', 'sm'],
    mainGoals: [
      {
        icon: require('@/assets/icons/sign-in.svg'),
        title: 'Sign In',
        contentSlug: 'introduction-sign-in',
        buttonText: 'Sign in/up',
        buttonTo: '/sign-in',
        backgroundColor: '#D42526',
        backgroundImage: require('@/assets/01.svg'),
      },
      {
        icon: require('@/assets/icons/create.svg'),
        title: 'Create',
        contentSlug: 'introduction-create',
        buttonText: 'Learn',
        buttonTo: '/learn',
        backgroundColor: '#D53D25',
        backgroundImage: require('@/assets/02.svg'),
      },
      {
        icon: require('@/assets/icons/describe.svg'),
        title: 'Describe',
        contentSlug: 'introduction-add-project',
        buttonText: 'Add a project',
        buttonTo: '/project/new',
        backgroundColor: '#EE631A',
        backgroundImage: require('@/assets/03.svg'),
      },
      {
        icon: require('@/assets/icons/join-to-the-contest.svg') ,
        title: 'Join to the contest',
        contentSlug: 'introduction-win',
        buttonText: 'Our contests',
        buttonTo: '/contests/open',
        backgroundColor: '#EE7F1A',
        backgroundImage: require('@/assets/04.svg'),
      },
    ],
  }),
})
